<template>
    <v-row align="center" justify="center">
        <v-col cols="12" sm="6" md="4" lg="3" xl="2">
            <div class="mx-auto">
                    <v-form ref="form" v-model="valid">
                        <v-row no-gutters>
                            <v-col cols="12">
                                <div class="d-flex justify-center mb-4">
                                    <img width="150" src="../assets/Logo1.png"/>
                                </div>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field 
                                    :label="$t('username')" 
                                    single-line
                                    v-model="form.username"
                                    outlined 
                                    :rules="rules.username" 
                                    append-icon="mdi-account"
                                    background-color="white"
                                    >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field 
                                    single-line
                                    :label="$t('password')" 
                                    background-color="white" 
                                    v-model="form.password"
                                    :rules="rules.password" 
                                    outlined
                                    @keyup.enter="submit" 
                                    append-icon="mdi-lock"
                                    type="password">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-btn
                                    x-large
                                    color="primary"
                                    :loading="loading.submit" 
                                    @click="submit" 
                                    block>
                                    {{ this.$t("login") }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
            </div>
        </v-col>
        <AlertDialog ref="alertDialog" />
    </v-row>
</template>

<script>
import AlertDialog from "@/components/common/AlertDialog";
import { mapActions, mapState } from "vuex";
export default {
    name: "TheLogin",
    components: {
        AlertDialog,
    },
    data() {
        return {
            valid: false,
            loading: {
                data: false,
                submit: false,
            },
            form: {
                username: null,
                password: null,
            },
            rules: {
                username: [(v) => !!v || this.$t("rules_required")],
                password: [(v) => !!v || this.$t("rules_required")],
            },
        };
    },
    computed: {
        ...mapState("authentication", ["logoutMessage"]),
    },
    methods: {
        ...mapActions("authentication", ["login", "fetchPermissions"]),
        ...mapActions("common/snackBar", ["setSnackBars"]),
        submit() {
            if(!this.$refs.form.validate()) return;
            this.loading.submit = true;
            this.login(this.form)
                .then((response) => {
                    this.fetchPermissions()
                    this.$router.push({ name: "Profile" });
                    if(response.data.message) this.setSnackBars({ color: "black", message: response.data.message});
                    this.loading.submit = false;
                })
                .catch((error) => {
                    if(error.response) {
                        if(error.response.status == 406 && error.response.data.code == "MUST_CHANGE_PASSWORD") {
                            this.$router.push({
                                path: "/change-password",
                                query: {
                                    username: this.form.username
                                }
                            })
                            return;
                        }
                    }
                    this.loading.submit = false;
                    let message = error.response ? error.response.data.message : error;
                    this.setSnackBars({ color: "error", message });
                });
        },
    }
};
</script>
